import Link from 'next/link'
//import FacebookIcon from '@/assets/icons/icon-facebook.svg'
import InstagramIcon from '@/assets/icons/icon-instagram.svg'
import LinkedInIcon from '@/assets/icons/icon-linkedin.svg'
import YoutubeIcon from '@/assets/icons/icon-youtube.svg'
import WideGrayLogo from '@/assets/images/bi_wide_gray.svg'
import { CAREER_PATH } from '@/constants/routes'
import { POLICY } from '@/constants/routesPolicy'
import { useCustomRouter } from '@/features/common/hooks/useCustomRouter'
import { callRepresentPhone, sendMailTo } from '@/utils/contacts'
import { sendCustomEvent } from '@/utils/GTM'
import BuildUtils from '@/utils/buildUtils'

function Footer() {
  const { handleExternalLink } = useCustomRouter()

  const handleExternalRoute = (url: string) => {
    let label: string = ''

    if (url.includes('youtube')) {
      label = '소셜 - 유튜브'
    } else if (url.includes('instagram')) {
      label = '소셜 - 인스타그램'
    } else if (url.includes('facebook')) {
      label = '소셜 - 페이스북'
    } else if (url.includes('linkedin')) {
      label = '소셜 - 링크드인'
    }

    sendCustomEvent({ event: 'click', category: '소셜 이동 클릭', label, value: url })
    handleExternalLink(url)
  }

  return (
    <>
      <footer className='footer-navigation-wrapper'>
        <div className='container'>
          <div className='container__left'>
            <p>
              <WideGrayLogo style={{ width: 138 }} />
            </p>
            <div>
              <ul>
                <li>
                  <p>
                    <span>씨제이대한통운(주)</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>사업자등록번호</span>
                  </p>
                  <p>
                    <span>110-81-05034</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>대표자</span>
                  </p>
                  <p>
                    <span>신영수,민영학</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>대표번호</span>
                  </p>
                  <p>
                    <a href='#' onClick={callRepresentPhone} title='대표번호 연결'>
                      {process.env.NEXT_PUBLIC_APP_TELNO}
                    </a>
                  </p>
                </li>
                <li>
                  <p>
                    <span>제휴문의</span>
                  </p>
                  <p>
                    <a href='#' onClick={sendMailTo} title='제휴문의 메일 보내기'>
                      {process.env.NEXT_PUBLIC_APP_MAILTO}
                    </a>
                  </p>
                </li>
              </ul>
              <p>
                <span>COPYRIGHT © {new Date().getFullYear()}. CJ Logistics Corporation. ALL RIGHTS RESERVED.</span>
              </p>
              <nav>
                <Link href={POLICY.SERVICE}>이용약관</Link>
                <Link href={POLICY.OWNER.TRANSPORT}>운송약관</Link>
                <Link href={POLICY.PERSONAL.PRIVACY} className='bold'>
                  개인정보 처리방침
                </Link>
                <Link href={POLICY.DRIVER.LOCATION}>위치기반 서비스약관</Link>
              </nav>
            </div>
          </div>
          <div className='container__right'>
            <button
              title='더 운반 유튜브 공식 채널로 이동'
              onClick={() => handleExternalRoute('https://www.youtube.com/@the_unban')}
            >
              <YoutubeIcon />
            </button>
            {/*<button*/}
            {/*  title='더 운반 페이스북 공식 페이지로 이동'*/}
            {/*  onClick={() => handleExternalRoute('https://www.facebook.com/theunban')}*/}
            {/*>*/}
            {/*  <FacebookIcon />*/}
            {/*</button>*/}
            <button
              title='더 운반 링크드인 공식 계정으로 이동'
              onClick={() => handleExternalRoute('https://www.linkedin.com/in/%EC%9A%B4%EB%B0%98-%EB%8D%94-a24466276/')}
            >
              <LinkedInIcon />
            </button>
            <button
              title='더 운반 인스타그램 공식 계정으로 이동'
              onClick={() => handleExternalRoute('https://www.instagram.com/theunban/')}
            >
              <InstagramIcon />
            </button>
          </div>
        </div>
      </footer>

      {!BuildUtils.isProduction() && (
        <p
          style={{
            width: '100%',
            padding: '0 10px',
            background: `linear-gradient(270deg, ${BuildUtils.getEnvColor()} 0%, rgba(255,255,255,1) 40%)`,
            lineHeight: '25px',
            textAlign: 'right',
            verticalAlign: 'middle',
            textTransform: 'uppercase',
            fontSize: '11px',
            color: '#666',
          }}
        >
          <span>{BuildUtils.getEnvName()}</span>
          <span> / 빌드 버전: {process.env.APP_VERSION}</span>
          <span> / 최종빌드시간: {process.env.APP_BUILD_DATETIME}</span>
        </p>
      )}
    </>
  )
}

export default Footer
